export const loadData = (data) => ({
  type:"LOAD",
  payload: data
})